import Vue from 'vue'
import Router from 'vue-router'
import { api_refreshToken } from '@/request/api'

import { REFRESH_TIME, EXPIRES_TIME } from '@/assets/js/config'
const Login = () => import('../components/login.vue')
const Index = () => import('../components/main.vue')
const SelectClass = () => import('../components/select-class.vue')
const ProjectDetail = () => import('../components/project-detail.vue')
const PreCheck = () => import('../components/pre-check.vue')
const PreCheckResult = () => import('../components/pre-check-result.vue')
const OrderExperiment = () => import('../components/order-experiment.vue')
const OrderMakeup = () => import('../components/order-makeup.vue')

const MakeupItem = () => import('../components/makeup-item.vue')
const Evaluate = () => import('../components/evaluate.vue')
const waitSelect = () => import('../components/wait-select.vue')
const waitCheck = () => import('../components/wait-check.vue')
const waitOrder = () => import('../components/wait-order.vue')
const waitClass = () => import('../components/wait-class.vue')

const Class = () => import('../components/my-class.vue')
const Schedule = () => import('../components/my-schedule.vue')
const Exercitation = () => import('../components/my-exercitation.vue')
const ExercitationDetail = () => import('../components/exercitation-detail.vue')

const Score = () => import('../components/my-score.vue')
const Makeup = () => import('../components/my-makeup.vue')


Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/wait-select'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/wait-select',
      name: 'Index',
      component: Index,
      redirect: '/wait-select',
      children: [
        {
          path: '/wait-select',
          name: 'waitSelect',
          component: waitSelect,
          meta: {
            index: 0
          }
        },
        {
          path: '/wait-check',
          name: 'waitCheck',
          component: waitCheck,
          meta: {
            index: 1
          }
        },
        {
          path: '/wait-order',
          name: 'waitOrder',
          component: waitOrder,
          meta: {
            index: 2
          }
        },
        {
          path: '/wait-class',
          name: 'waitClass',
          component: waitClass,
          meta: {
            index: 3
          }
        },

        {
          path: '/select-class/:id',
          name: 'SelectClass',
          component: SelectClass
        },
        {
          path: '/project-detail/:id',
          name: 'ProjectDetail',
          component: ProjectDetail
        },
        {
          path: '/pre-check/:id',
          name: 'PreCheck',
          component: PreCheck
        },
        {
          path: '/pre-check-result',
          name: 'PreCheckResult',
          component: PreCheckResult
        },
        {
          path: '/order-experiment/:id',
          name: 'OrderExperiment',
          component: OrderExperiment
        },
        {
          path: '/order-makeup',
          name: 'OrderMakeup',
          component: OrderMakeup
        },
        {
          path: '/my-class',
          name: 'Class',
          component: Class
        },
        {
          path: '/my-schedule',
          name: 'Schedule',
          component: Schedule
        },
				{
					path: '/my-exercitation',
          name: 'Exercitation',
          component: Exercitation
				},
				{
					path: '/exercitation-detail/:id',
          name: 'ExercitationDetail',
          component: ExercitationDetail
				},
        {
          path: '/my-score',
          name: 'Score',
          component: Score
        },
        {
          path: '/my-makeup',
          name: 'Makeup',
          component: Makeup
        },

        {
          path: '/makeup-item/:id',
          name: 'MakeupItem',
          component: MakeupItem
        },
        {
          path: '/evaluate',
          name: 'Evaluate',
          component: Evaluate
        }
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {

  //重定向到【login】的时候均需要判断，否则出错
  let auth_time = localStorage.getItem('auth_time')
  if (!auth_time) { // 首次进入系统，本地什么都没有，直接去登陆页面
    if (to.path === '/login') {
      return next()
    } else {
      return next({
        path: '/login',
        query: { redirect: to.path }
      })
    }
  }
  let refresh_time = new Date().getTime() / 1000 - auth_time

  if (refresh_time >= REFRESH_TIME && refresh_time < EXPIRES_TIME) {
    console.log('token快过期了，这里要调刷新token的接口')
    let refresh_token = localStorage.getItem('refresh_token').slice(1, -1)
    api_refreshToken({
      token: refresh_token
    }).then(res => {
      localStorage.setItem('token', res.access_token)
      localStorage.setItem('refresh_token', res.refresh_token)
      localStorage.setItem('auth_time', new Date().getTime() / 1000)
    })
    next()
  } else if (refresh_time > EXPIRES_TIME) { // token过期，删除token，重新登陆
    console.log('token过期了，这里要重新登陆')
    localStorage.removeItem('token')
    if (to.path === '/login') {
      return next()
    } else {
      return next({
        path: '/login',
        query: { redirect: to.path }
      })
    }
  } else {
    console.log('token正常');
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js